import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TaskTemplatesService {
  getTaskTemplates() {
    return ApiService.get(`${Config.api.document.url}api/v1/task-templates`).then((response) => response.data);
  }

  createTaskTemplate(data) {
    return ApiService.post(`${Config.api.document.url}api/v1/task-templates`, {
      title: data.title,
      description: data.description,
    }).then((response) => response.data);
  }

  updateTaskTemplate(data) {
    return ApiService.put(`${Config.api.document.url}api/v1/task-templates/${data.id}`, {
      title: data.title,
      description: data.description,
    }).then((response) => response.data);
  }

  deleteTaskTemplate(id) {
    return ApiService.delete(`${Config.api.document.url}api/v1/task-templates/${id}`).then((response) => response.data);
  }
}

export const taskTemplatesService = new TaskTemplatesService();
